import { render, staticRenderFns } from "./image-holder.vue?vue&type=template&id=77854e92&scoped=true"
import script from "./image-holder.vue?vue&type=script&lang=js"
export * from "./image-holder.vue?vue&type=script&lang=js"
import style0 from "./image-holder.vue?vue&type=style&index=0&id=77854e92&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "77854e92",
  null
  
)

export default component.exports